import React from "react"

import { NO, YES } from "const"
import { LangType } from "client/store"
import { TableColumnEditable } from "client/components"

import { MtPackage } from "server/models"

import TableSelect from "../components/select"

const Markov = (lang: LangType) => {
    const columns: TableColumnEditable[] = [
        {
            field: "markovModuleAccess",
            header: lang.markovModuleAccess,
            formatter: (packg: MtPackage) => {
                const { markovModuleAccess } = packg.settingsParsed
                return lang[markovModuleAccess]
            },
            focusedFormatter: (packg: MtPackage) => {
                const { markovModuleAccess } = packg.settingsParsed
                return (
                    <TableSelect
                        text={lang[markovModuleAccess]}
                        label={lang.markovModuleAccess}
                        property={{ markovModuleAccess }}
                        propertyArray={[NO, YES]}
                    />
                )
            },
        },
    ]

    return columns
}
export default Markov
